import { render } from "./FriendSearchModal.vue?vue&type=template&id=1e4e3834&scoped=true&ts=true"
import script from "./FriendSearchModal.vue?vue&type=script&lang=ts"
export * from "./FriendSearchModal.vue?vue&type=script&lang=ts"

import "./FriendSearchModal.vue?vue&type=style&index=0&id=1e4e3834&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4e3834"]])

export default __exports__